/**
 * Spacing design tokens
 */
export const SpacingTokens = {
    // Base spacing scale (in pixels)
    none: 0,
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 48,
    xxxl: 64,

    // Component-specific spacing
    component: {
        paddingSmall: 5,
        paddingMedium: 10,
        paddingLarge: 15,
        gapSmall: 8,
        gapMedium: 16,
        gapLarge: 24,
    },

    // Menu spacing
    menu: {
        itemSpacing: 20,
        horizontalGap: 16,
        verticalGap: 16,
    },
};
